import React from 'react';
import { intlShape } from 'react-intl';
import { nfd } from 'unorm';

const createLocalizable = (WrappedComponent, displayName) => {
  function getDisplayName(component) {
    return (
      displayName || component.displayName || component.name || 'Component'
    );
  }

  function getCanonicalId(text) {
    return text
      ? nfd(text)
          .replace(/[\s]+/g, '_')
          .replace(/[^\w0-9_]+/g, '')
          .toLowerCase()
      : '';
  }

  function formatMessage(text, values, props, context, defaultText) {
    // react-intl does Object.keys(values), which throws on null
    values = values || undefined;

    var namespace = '';
    var index = text ? text.indexOf('::') : -1;
    if (index >= 0) {
      // handle the case where namespace is already specified in the text
      namespace = text.substring(0, index);
      text = text.substring(index + 2); // strip the namespace from the text
    } else namespace = getDisplayName(WrappedComponent);

    if (namespace !== '') namespace += '::'; // strings in 'global' namespace do not contain '::'

    const canonicalId = getCanonicalId(text);

    // For some reason context.intl.formatMessage() does not recognize resource strings containing double curly braces
    // (e.g. 'ImageUpload::cloudinary_queue_title_uploading_with_counter': '{{num}} Assets hochladen')
    // unless the default message contains curly braces too.
    const defaultMessage = '{_}';

    var id = `${namespace}${canonicalId}`;
    var localized = context.intl.formatMessage({ id, defaultMessage }, values);

    if (localized === defaultMessage) {
      if (namespace !== '' && !!canonicalId) {
        // try in 'global' namespace
        id = canonicalId;
        localized = context.intl.formatMessage({ id, defaultMessage }, values);
      }
    }

    // go with defaultText if provided
    if (localized === defaultMessage && defaultText) {
      return formatMessage(defaultText, values, props, context);
    }

    if (localized === defaultMessage) {
      console.log(
        `[localizable]: Missing localization for ${namespace}${canonicalId}`
      );
      return context.intl.formatMessage(
        { id: `${namespace}${canonicalId}`, defaultMessage: text },
        values
      );
    }

    // return '✓ ' + localized + ' ✓';
    if (
      process.env.REACT_APP_LOCALIZATION_ASSISTANT === true ||
      process.env.REACT_APP_LOCALIZATION_ASSISTANT === 'true'
    )
      return localized + '~' + id + '~';
    else return localized;
  }

  const localizable = (props, context) => (
    <WrappedComponent
      {...props}
      intl={context.intl}
      t={(text, values, defaultText) =>
        formatMessage(text, values, props, context, defaultText)
      }
    />
  );

  localizable.contextTypes = {
    intl: intlShape,
  };

  localizable.displayName =
    displayName || `localizable(${getDisplayName(WrappedComponent)})`;

  return localizable;
};

// export function localizable() {
//   let WrappedComponent = arguments[arguments.length - 1];
//   let displayName = arguments.length > 1 ? arguments[0] : null;

//   return createLocalizable(WrappedComponent, displayName);
// }

export function localizable() {
  if (typeof arguments[0] === 'function') {
    const componentClass = arguments[0];
    return createLocalizable(componentClass, undefined);
  } else {
    const displayName = arguments[0];
    return function (componentClass) {
      return createLocalizable(componentClass, displayName);
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Localization/index.jsx